import React from "react";
//#region types
import { GraphConstants } from "utils/constants";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { ChartEnums } from "models/enums";
//#endregion
//#region components
import { ChartContainer } from "components/common";
//#endregion
import { DateHelper, LocalizationHelperInstance, QueryStateHelper, UrlHelper } from "utils/helpers";
import { FormFieldConstants } from "utils/constants";
import { useLocation, useNavigate } from "react-router-dom";
import ReportWidgetType = WintSuperkollAPIModel.ReportWidgetType;
import { TranslationKeys } from "translations";
import { AccountingCategoryType } from "../../../models/enums/accounting";

const OperatingProfitBarChart: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const generateLabels = (chartData?: WintSuperkollAPIModel.ReportWidget): string[] => {
    let labels = [""];
    if (chartData?.data) {
      labels = DateHelper.getYearsBetween(chartData.data[0].startDate, chartData.data[0].endDate);
    }
    return labels;
  };

  const bookingDateEncoder = QueryStateHelper.dateRangeQueryEncoder(
    FormFieldConstants.Accounting.CompanyBooksReportFilter.BookingDate
  );

  const categoryIdEncoder = QueryStateHelper.numberQueryEncoder(
    FormFieldConstants.Accounting.CompanyBooksReportFilter.CategoryId
  );
  const categoryEncoder = QueryStateHelper.stringQueryEncoder(
    FormFieldConstants.Accounting.CompanyBooksReportFilter.Category
  );

  const operatingProfitCategoryId = AccountingCategoryType.SumOperatingIncome;

  return (
    <ChartContainer
      useSkeleton={ReportWidgetType.Bar}
      chartAPIKey={GraphConstants.ChartKeys.OperatingProfitFiscalYear}
      chartCacheKey={GraphConstants.ChartKeys.OperatingProfitFiscalYear}
      customLabelsHandler={generateLabels}
      useClickableChart
      onPeriodClick={({ start, end }) => {
        if (!start || !end) return;
        const params = new URLSearchParams("");
        bookingDateEncoder.urlEncode(params, undefined, { start, end });

        categoryIdEncoder.urlEncode(params, undefined, operatingProfitCategoryId);
        categoryEncoder.urlEncode(
          params,
          undefined,
          LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.OperatingProfit)
        );
        navigate(`${UrlHelper.formatPath(`/Reports/Accounting`)}?${params.toString()}`, {
          state: { background: location },
        });
      }}
      hideLegend
      yAxisTickUnit={ChartEnums.YAxisTickUnitType.Currency}
      overrideLabelFontSize={10}
    />
  );
};

export default OperatingProfitBarChart;
